var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("../../../assets/images/winterGame/notification.png")}}),(_vm.dotShow)?_c('div',{staticClass:"dot"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }